var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:fire-fill",
    clipPath: "url(#clip0_5032_48469)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.20341 1.47604L6.43341 1.01465L6.28674 1.90015C6.05329 3.29837 5.09813 4.59759 4.04457 5.51059C1.98207 7.2987 1.53046 9.24204 2.16907 10.8462C2.78018 12.3813 4.33118 13.4324 5.90541 13.6078L6.26963 13.6481C5.36885 13.0975 4.79074 11.8112 4.99241 10.8499C5.19163 9.9051 5.87118 9.0202 7.17652 8.20376L7.83468 7.79309L8.08035 8.52948C8.22518 8.96459 8.47574 9.31415 8.73057 9.6692C8.8528 9.84032 8.97685 10.0133 9.09052 10.1972C9.48346 10.8358 9.58735 11.5459 9.33374 12.2505C9.10274 12.891 8.72141 13.3945 8.19707 13.6738L8.78985 13.6078C10.2675 13.4434 11.3522 12.938 12.0569 12.0929C12.7554 11.255 13.0004 10.1764 13.0004 9.02815C13.0004 7.9587 12.561 6.85626 12.0428 5.93898C11.4354 4.86465 10.6427 3.97243 9.77741 3.1077C9.62768 3.40715 9.6393 3.52815 9.3313 4.00909C8.9315 2.94686 8.18072 2.05313 7.20341 1.47604Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5032_48469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6667,
    height: 14.6667,
    fill: "white",
    transform: "translate(0.166992 0.166992)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.ccde2871461a224a1124fc9b9de260fb.svg";
export { ForwardRef as ReactComponent };